export const DEMO_CALENDLY_URL = "https://calendly.com/tribesocial/demo";
export const DEMO_CALENDLY_EMBED_URL = `${DEMO_CALENDLY_URL}?hide_event_type_details=1&hide_gdpr_banner=1&text_color=091235&primary_color=2f7fe2`;

export const CONSUMER_CALENDLY_URL = DEMO_CALENDLY_URL;
export const CREATOR_CALENDLY_URL = DEMO_CALENDLY_URL;

export const DOCS_URL = "https://docs.tribe.social";

export const MARKETING_PATHS = Object.freeze({
  HOME: "/",
  FEATURES: "/features",
  COURSES: "/features/courses",
  FEED: "/features/feed",
  LIVE_CALL: "/features/live-call",
  LEGACY_PAYMENTS: "/features/payments",
  PRICING: "/pricing",
  BOOK_DEMO: "/book-demo",
  PRIVACY: "/privacy",
  TERMS: "/terms",
  SUBSCRIPTION_TERMS: "/subscription-terms",
  PRO_SLA: "/pro-sla",
  HELP: "/help",
  PRO: "/pro",
  // Unlinked on purpose: /estimate is shared as a direct link and stays out of the nav,
  // the footer, and sitemap.xml.
  ESTIMATE: "/estimate",
  HOME_PREVIEW: "/preview/home-v1",
  MARKETING_PREVIEW: "/preview/marketing"
});

export const MARKETING_SCALE_METRIC = "500,000+";

export const MARKETING_SOCIAL_URLS = Object.freeze({
  X: "https://twitter.com/TribeSocialApp",
  YOUTUBE: "https://www.youtube.com/@tribesocial",
  INSTAGRAM: "https://www.instagram.com/tribesocial.io/",
  FACEBOOK: "https://www.facebook.com/tribesocial.io/"
});

export const MARKETING_FATHOM_SITE_ID =
  process.env.REACT_APP_MARKETING_FATHOM_SITE_ID || "MKCEYNBJ";
export const MARKETING_FACEBOOK_PIXEL_ID =
  process.env.REACT_APP_MARKETING_FACEBOOK_PIXEL_ID || "1385323188524798";
export const MARKETING_DATAFAST_WEBSITE_ID = "dfid_byWt5FWnsVS2WbKlsSUIO";
